"use strict";
/*
 * Created on 03 04 2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var CodebookLookupSequence_1 = require("../../../core/model/codebook/CodebookLookupSequence");

var DateParser_1 = require("../../../core/model/data-dictionary/parsers/DateParser");

var StructPropBuilder_1 = require("../../../core/model/data-dictionary/StructPropBuilder");

var ValidationResult_1 = require("../../../core/model/errors/ValidationResult");

var ValidationResultObject_1 = require("../../../core/model/errors/ValidationResultObject");

var AbstractReleaseItem_1 = require("../AbstractReleaseItem");

var FinalProductPriceValidationKey_1 = require("../FinalProductPriceValidationKey");

var SelloutReleaseItemEvaluation_1 = require("./SelloutReleaseItemEvaluation");

var SelloutReleaseItemPrices_1 = require("./SelloutReleaseItemPrices");

var SelloutReleaseItemSnapshot_1 = require("./SelloutReleaseItemSnapshot");

var SelloutReleaseItemSupplyData_1 = require("./SelloutReleaseItemSupplyData");

var SelloutReleaseType_1 = require("./SelloutReleaseType");

var SelloutSourceImpactValues_1 = require("./SelloutSourceImpactValues");
/**
 * <p>
 * Release item specific to {@link SelloutRelease sellout release}. Sellout release is based on products which should be sold out
 * in particular sites. In sellout release, we think about release item as single item to be repriced, thus it has direct association
 * to {@link InternalSite internal site}.
 * </p>
 *
 * <p>
 * Information that are not persisted for now (they can be loaded from other entities, mainly based on information within product):
 * </p>
 *
 * <ul>
 *     <li>name of category at level 6,</li>
 *     <li>product flags,</li>
 *     <li>family name,</li>
 *     <li>product sensitivity,</li>
 *     <li>site name.</li>
 * </ul>
 *
 * <p>
 * Note: if you try to add new attributes, try to consider the order within constructor with respect to data semantic,
 * not just adding it to the end.
 * </p>
 *
 * @author JMe
 * @author Radek Beran
 */


var SelloutReleaseItem =
/*#__PURE__*/
function (_AbstractReleaseItem_) {
  _inherits(SelloutReleaseItem, _AbstractReleaseItem_);

  /**
   * @param id internal id of release item
   * @param releaseId internal id of release
   * @param releaseType sellout release type, is part of this object to optimize some queries
   * @param siteId internal id of internal site on which product should be sold out to required amount
   * @param productId internal id of company's product
   * @param productExternalId external id of company's product
   * @param productName name of product
   * @param categoryIds product categories to which product belongs (product category tree, same as {@link Product.categoryIds}
   *        todo synchronization after product category is changed?
   * @param weighted denotes that item with this flag is weighted (e.g. for transaction, sales and supply, respectively)
   * @param categorySpacePlanning code and name of category from space planning (external system), only filled for some types of sellouts
   *        todo we do not integrate this information, RFC will be created
   *        specific value for product-site level, or value taken from release-level
   * @param minPriceChangeInPercent minimal price change that should be applied to current regular price; specific value for product-site
   *        level, or value taken from release-level
   * @param maxPriceChangeInPercent maximum price change that should be applied to current regular price; specific value for product-site
   *        level, or value taken from release-level (PROFACT-608)
   * @param minMarginChangeInPercent minimal change (reduction) of margin that should be applied to; specific value for
   *        product-site level, or value taken from release-level
   * @param endDate Last moment when the item can be sold. After that it shall be already sold out. Default value is retaken from whole
   *        release entity, for some sellout types, value is recalculated according to custom sellout type rules. Value of this attribute
   *        should not be changed after release is opened. Is null for an urgent release.
   * @param supplyData encapsulates information about supply of release item;
   *        null for items without supplies from external system (e.g. Returnable items, some items in urgent releases)
   * @param supplierId preferred supplier; be aware that it is also used to store supplier reference of uploaded release items
   * @param prices prices for product-site level
   * @param evaluation evaluation of running sellout price of release item. It is null if price has not been valid yet
   * @param readonly release item should be readonly (attribute can be set also later in release process, eg. based on an event)
   * @param uploaded flag indicating whether release item has been created based on a record of uploaded file
   * @param exported flag indicating whether release item should be/has been exported to external system
   * @param reexport flag indicating that release item should be re-exported to external system, it should be reset to false after export
   * @param exportedDate date when this item has been exported (last date for some release types where the item can be exported multiple
   *        times). ExportedPriceListRow will maintain the whole export history.
   * @param selloutDetected a date the sellout of this item was first detected (imported from external system)
   * @param selloutEnded Flag indicating whether sellout has already been ended.
   * @param terminatedByUser Flag which determines whether this item was terminated by user using sellout prices termination tool. It
   *        does not mean that item, which was terminated to future date, cannot be terminated again by user or cannot be terminated
   *        automatically by sellout rules. If an item is after all terminated automatically, this flag will be set to false. See
   *        {@link SelloutTermination} and related components for more info about termination process by user.
   * @param validationResult validation messages (alerts)
   * @param reopenSnapshots Partial snapshots of release item created during reopens.
   * @param endReason External id of the reason why the sellout ended. TODO add link to code book item when implemented
   * @param newSelloutTypes Sellout types identified at this sellout termination date. Validity expiration excluded.
   * @param sourceImpactValuesHistory Source values for impact report computation. Related to price intervals in
   *        {@link SelloutReleaseItemPrices#exportedPriceHistory}. There is one record for one non-deleted interval. Non-empty
   *        for exported release items.
   */
  function SelloutReleaseItem(id, releaseId, releaseType, siteId, productId, productExternalId, productName, categoryIds, weighted, categorySpacePlanning, minPriceChangeInPercent, // null in Urgent
  maxPriceChangeInPercent, minMarginChangeInPercent, // null in Urgent
  endDate, // null in Urgent
  supplyData, supplierId, prices, evaluation, readonly, uploaded, exported, reexport, exportedDate, selloutDetected, selloutEnded, terminatedByUser, validationResult, reopenSnapshots, endReason, newSelloutTypes, sourceImpactValuesHistory) {
    var _this;

    _classCallCheck(this, SelloutReleaseItem);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SelloutReleaseItem).call(this, id, releaseId, productId, productExternalId, productName, categoryIds, readonly, uploaded, exported, exportedDate, validationResult));
    _this.id = id;
    _this.releaseId = releaseId;
    _this.releaseType = releaseType;
    _this.siteId = siteId;
    _this.productId = productId;
    _this.productExternalId = productExternalId;
    _this.productName = productName;
    _this.categoryIds = categoryIds;
    _this.weighted = weighted;
    _this.categorySpacePlanning = categorySpacePlanning;
    _this.minPriceChangeInPercent = minPriceChangeInPercent;
    _this.maxPriceChangeInPercent = maxPriceChangeInPercent;
    _this.minMarginChangeInPercent = minMarginChangeInPercent;
    _this.endDate = endDate;
    _this.supplyData = supplyData;
    _this.supplierId = supplierId;
    _this.prices = prices;
    _this.evaluation = evaluation;
    _this.readonly = readonly;
    _this.uploaded = uploaded;
    _this.exported = exported;
    _this.reexport = reexport;
    _this.exportedDate = exportedDate;
    _this.selloutDetected = selloutDetected;
    _this.selloutEnded = selloutEnded;
    _this.terminatedByUser = terminatedByUser;
    _this.validationResult = validationResult;
    _this.reopenSnapshots = reopenSnapshots;
    _this.endReason = endReason;
    _this.newSelloutTypes = newSelloutTypes;
    _this.sourceImpactValuesHistory = sourceImpactValuesHistory;
    return _this;
  }

  _createClass(SelloutReleaseItem, [{
    key: "withMessage",
    value: function withMessage(message) {
      return this.copy('validationResult', this.validationResult.addObjectIfNotPresent(message));
    }
    /**
     * Updates exported flag on this release item based on new final price that is already part of this release item.
     * Returns updated item.
     */

  }, {
    key: "withExportedForNewPrice",
    value: function withExportedForNewPrice() {
      var finalPriceValue = this.prices.finalPrice !== null ? this.prices.finalPrice.getPresentedValue() : null;
      var exported = finalPriceValue !== null && !this.readonly;
      return this.copy('exported', exported);
    }
  }, {
    key: "validateFinalPriceVersusLastPromoPrice",
    value: function validateFinalPriceVersusLastPromoPrice(finalPrice) {
      var lastPromoPrice = this.prices.promoPriceStats.lastAmount;

      if (lastPromoPrice && lastPromoPrice.gt(finalPrice.getPresentedValue())) {
        return ValidationResultObject_1.ValidationResultObject.warning(FinalProductPriceValidationKey_1.FinalProductPriceMessageCode.FinalPriceLowerThanPreviousPromoPrice);
      }

      return null;
    }
    /**
     * AKA available supply price
     */

  }, {
    key: "getStockValue",
    value: function getStockValue() {
      return SelloutReleaseItem.getStockValue(this);
    }
    /**
     * AKA available supply
     */

  }, {
    key: "getStockVolume",
    value: function getStockVolume() {
      return SelloutReleaseItem.getStockVolume(this);
    }
    /**
     * AKA available supply before repricing price
     */

  }, {
    key: "getInitialStockValue",
    value: function getInitialStockValue() {
      return SelloutReleaseItem.getInitialStockValue(this);
    }
    /**
     * AKA available supply before repricing
     */

  }, {
    key: "getInitialStockVolume",
    value: function getInitialStockVolume() {
      return SelloutReleaseItem.getInitialStockVolume(this);
    }
    /**
     * Converter from data-dictionary representation
     */

  }], [{
    key: "fromDataDict",
    value: function fromDataDict(mat) {
      return new SelloutReleaseItem(mat.id, mat.releaseId, mat.releaseType, mat.siteId, mat.productId, mat.productExternalId, mat.productName, mat.categoryIds, mat.weighted, mat.categorySpacePlanning, mat.minPriceChangeInPercent, mat.maxPriceChangeInPercent, mat.minMarginChangeInPercent, mat.endDate, mat.supplyData, mat.supplierId, mat.prices, mat.evaluation, mat.readonly, mat.uploaded, mat.exported, mat.reexport, mat.exportedDate, mat.selloutDetected, mat.selloutEnded, mat.terminatedByUser, mat.validationResult, mat.reopenSnapshots, mat.endReason, mat.newSelloutTypes, mat.sourceImpactValuesHistory);
    }
    /**
     * Generic function to get available supply price.
     *
     * @param item
     */

  }, {
    key: "getStockValue",
    value: function getStockValue(item) {
      var stockVolume = SelloutReleaseItem.getStockVolume(item);
      var purchasePrice = item.prices.purchasePrice && item.prices.purchasePrice.avgPrice;
      return stockVolume && purchasePrice ? stockVolume.mul(purchasePrice.value) : null;
    }
    /**
     * Generic function to get available supply.
     *
     * @param item
     */

  }, {
    key: "getStockVolume",
    value: function getStockVolume(item) {
      return item.supplyData && item.supplyData.getStockAmount().value;
    }
    /**
     * Generic function to get available supply before repricing price
     *
     * @param item
     */

  }, {
    key: "getInitialStockValue",
    value: function getInitialStockValue(item) {
      var initialStockVolume = SelloutReleaseItem.getInitialStockVolume(item);
      var purchasePrice = item.prices.purchasePrice && item.prices.purchasePrice.avgPrice;
      return initialStockVolume && purchasePrice ? initialStockVolume.mul(purchasePrice.value) : null;
    }
    /**
     * Generic function to get available supply before repricing
     * @param item
     */

  }, {
    key: "getInitialStockVolume",
    value: function getInitialStockVolume(item) {
      var availableSupplyBeforeRepricingWithUnit = item.supplyData && item.supplyData.getStockAmountBeforeRepricing();
      return availableSupplyBeforeRepricingWithUnit && availableSupplyBeforeRepricingWithUnit.value;
    }
  }]);

  return SelloutReleaseItem;
}(AbstractReleaseItem_1.AbstractReleaseItem);

exports.SelloutReleaseItem = SelloutReleaseItem;

SelloutReleaseItem.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(SelloutReleaseItem.name);
  return {
    id: builder.id('id'),
    releaseId: builder.str('releaseId'),
    releaseType: builder.senum('releaseType', SelloutReleaseType_1.SelloutReleaseType, CodebookLookupSequence_1.CodebookLookupSequence.SelloutReleaseType),
    siteId: builder.str('siteId'),
    productId: builder.str('productId'),
    productExternalId: builder.str('productExternalId'),
    productName: builder.str('productName'),
    categoryIds: builder.listOf(builder.id('categoryIds')),
    weighted: builder.bool('weighted'),
    categorySpacePlanning: builder.opt(builder.str('categorySpacePlanning')),
    minPriceChangeInPercent: builder.opt(builder.bigNum('minPriceChangeInPercent')),
    maxPriceChangeInPercent: builder.opt(builder.bigNum('maxPriceChangeInPercent')),
    minMarginChangeInPercent: builder.opt(builder.bigNum('minMarginChangeInPercent')),
    endDate: builder.opt(builder.date('endDate', DateParser_1.DateParser.ISO_PATTERN)),
    supplyData: builder.opt(builder.obj('supplyData', SelloutReleaseItemSupplyData_1.SelloutReleaseItemSupplyData.schema, function (mat) {
      return SelloutReleaseItemSupplyData_1.SelloutReleaseItemSupplyData.fromDataDict(mat);
    })),
    supplierId: builder.opt(builder.str('supplierId')),
    prices: builder.obj('prices', SelloutReleaseItemPrices_1.SelloutReleaseItemPrices.schema, function (mat) {
      return SelloutReleaseItemPrices_1.SelloutReleaseItemPrices.fromDataDict(mat);
    }),
    evaluation: builder.opt(builder.obj('evaluation', SelloutReleaseItemEvaluation_1.SelloutReleaseItemEvaluation.schema, function (mat) {
      return SelloutReleaseItemEvaluation_1.SelloutReleaseItemEvaluation.fromDataDict(mat);
    })),
    readonly: builder.bool('readonly'),
    uploaded: builder.bool('uploaded'),
    exported: builder.bool('exported'),
    reexport: builder.bool('reexport'),
    exportedDate: builder.opt(builder.date('exportedDate', DateParser_1.DateParser.ISO_PATTERN)),
    selloutDetected: builder.date('selloutDetected', DateParser_1.DateParser.ISO_PATTERN),
    selloutEnded: builder.bool('selloutEnded'),
    terminatedByUser: builder.bool('terminatedByUser'),
    validationResult: builder.obj('validationResult', ValidationResult_1.ValidationResult.schema, function (mat) {
      return new ValidationResult_1.ValidationResult(mat.resultObjects);
    }),
    reopenSnapshots: builder.listOf(builder.obj('reopenSnapshots', SelloutReleaseItemSnapshot_1.SelloutReleaseItemSnapshot.schema, SelloutReleaseItemSnapshot_1.SelloutReleaseItemSnapshot.fromDataDict)),
    endReason: builder.opt(builder.str('endReason')),
    newSelloutTypes: builder.opt(builder.listOf(builder.senum('releaseType', SelloutReleaseType_1.SelloutReleaseType, CodebookLookupSequence_1.CodebookLookupSequence.SelloutReleaseType))),
    sourceImpactValuesHistory: builder.listOf(builder.obj('sourceImpactValuesHistory', SelloutSourceImpactValues_1.SelloutSourceImpactValues.schema, function (mat) {
      return SelloutSourceImpactValues_1.SelloutSourceImpactValues.fromDataDict(mat);
    }))
  };
}();